/* Beard & Brawn — header chrome: scroll-state (condense/blur + hide-down/show-up),
   the cart-badge "drop" micro-moment, and the outgoing half of the poured-navigation
   view-transition pair. Compositor-only, reduced-motion-safe, passive. */
(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastY = window.scrollY || 0;
  var ticking = false;

  function update() {
    var y = window.scrollY || 0;
    // solid/condensed once past the announcement bar
    header.classList.toggle('bb-scrolled', y > 72);
    if (!reduce) {
      var goingDown = y > lastY && y > window.innerHeight * 1.15;
      // never hide while a keyboard user is inside the header (menus/search/cart)
      if (goingDown && !header.contains(document.activeElement) && !document.body.classList.contains('overflow-hidden-mobile')) {
        header.classList.add('bb-hidden');
      } else if (y < lastY) {
        header.classList.remove('bb-hidden');
      }
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();
})();

